import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';



import { UtilService } from './util-service';
import { GestaoPcaService } from './gestao-pca-service';

import { saveAs } from 'file-saver';

/*
  Generated class for the OrcamentoService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class OrcamentoService {
  urlObterQuestoes: string;
  codigoModuloOrcamento = 12;
  analiseAtual: any = null;
  idPaginaOrcamento: string = "961";
  resumoAnalise: any;

  constructor(public http: HttpClient,
    private gestaoPcaService: GestaoPcaService,
    private utilService: UtilService) {
  }

  public obterIdPaginaOrcamento() {
    return this.idPaginaOrcamento;
  }

  public obterListaAnalises(codModulo): Observable<any> {
    this.urlObterQuestoes = "analiseOrcamentaria/?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public obterListaAnalisesJur(codModulo): Observable<any> {
    this.urlObterQuestoes = "orcamento?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }



  //apagar abaixo
  /* ======================================================================
  *
  *  Requisiçoes de Relatório
  *
  ========================================================================= */

  obterListaOrcamentos(): Observable<any> {
    let urlObtencaoDados: string = "orcamento/listar/" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  submeterOrcamento(relatorio): Observable<any> {
    let urlObtencaoDados: string = "orcamento/salvar";
    return this.utilService.postJSON(urlObtencaoDados, relatorio);
  }

  removerOrcamento(relatorio): Observable<any> {
    let urlObtencaoDados: string = "orcamento/deletar/" + relatorio.idOrcamento;
    return this.utilService.postJSON(urlObtencaoDados, relatorio);
  }


  listarArquivos(relatorio): Observable<any> {
    let urlObtencaoDados: string = "arquivoOrcamento/listar/" + relatorio.idOrcamento;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarArquivo(event, relatorio) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('arquivoOrcamento', file, file.name);
      let envioRolXml: string = "arquivoOrcamento/salvar/" + relatorio.idOrcamento;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  deletarArquivo(arquivo): Observable<any> {
    let urlObtencaoDados: string = "arquivoOrcamento/deletar/" + arquivo.idArquivoOrcamento;
    return this.utilService.deleteJSON(urlObtencaoDados);
  }

  public downloadfile(arquivo: any) {
    var headers = new HttpHeaders();
    headers.append('responseType', 'arraybuffer');
    this.utilService.getJSON("arquivoOrcamento/download/" + arquivo.idArquivoOrcamento)
      .subscribe(data => {
        // if (data.length <= 0) {
        let contentType = "data:" + data.mimeType + ";base64";

        let byteCharacters = atob(data.decodedFile);

        let byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: contentType });
        saveAs(file, arquivo.nmArquivo);
        // }else{
        // }
      },
        error => console.log("Error downloading the file. error: " + error));
  }

  public obterPreviewCertificado(): Observable<any> {
    this.urlObterQuestoes = "analiseOrcamentaria/obterCertificado?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }


  // ------------------------------------------ Analista ------------------------------------------------- //

  // RGN01

  public obterDifDotacoes(): Observable<any> {
    this.urlObterQuestoes = "analiseOrcamentaria/obterAnaliseDifDotacao?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarDifDotacoes(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseOrcamentaria/salvarAnaliseDifDotacao";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterDifDotacoes(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseOrcamentaria/submeterAnaliseDifDotacao";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // RGN02

  public obterConsDespesas(): Observable<any> {
    this.urlObterQuestoes = "analiseOrcamentaria/obterAnaliseConsDespesa?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarConsDespesas(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseOrcamentaria/salvarAnaliseConsDespesas";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterConsDespesas(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseOrcamentaria/submeterAnaliseConsDespesas";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // RGN03

  public obterMetasPercentual(): Observable<any> {
    this.urlObterQuestoes = "analiseOrcamentaria/obterAnaliseMetas?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarMetasPercentual(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseOrcamentaria/salvarAnaliseMetas";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterMetasPercentual(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseOrcamentaria/submeterAnaliseMetas";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }


  // RGN04

  public obterExecucaoXMetas(): Observable<any> {
    this.urlObterQuestoes = "analiseOrcamentaria/obterAnaliseExecucaoXMetas?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarExecucaoXMetas(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseOrcamentaria/salvarAnaliseExecucaoXMetas";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterExecucaoXMetas(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseOrcamentaria/submeterAnaliseExecucaoXMetas";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // RGN05

  public obterExerciciosAnteriores(): Observable<any> {
    this.urlObterQuestoes = "analiseOrcamentaria/obterAnaliseExerciciosAnteriores?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarExerciciosAnteriores(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseOrcamentaria/salvarAnaliseExerciciosAnteriores";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterExerciciosAnteriores(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseOrcamentaria/submeterAnaliseExerciciosAnteriores";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // RGN06

  public obterAquisicaoBens(): Observable<any> {
    this.urlObterQuestoes = "analiseOrcamentaria/obterAnaliseAquisicaoBens?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAquisicaoBens(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseOrcamentaria/salvarAnaliseAquisicaoBens";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterAquisicaoBens(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseOrcamentaria/submeterAnaliseAquisicaoBens";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }
}




// WEBPACK FOOTER //
// ./src/providers/orcamento-service.ts